import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class EzshareParameterService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getEzsharedParameters(operationNumber) {
        console.log("EzshareParameterService getEzsharedParameters");
        return this.httpClient.get(environment.api.base + 'convergences/ezshare?operationNumber=' + operationNumber, { responseType: 'text' });
    }
}
EzshareParameterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EzshareParameterService_Factory() { return new EzshareParameterService(i0.ɵɵinject(i1.HttpClient)); }, token: EzshareParameterService, providedIn: "root" });
